import { render, staticRenderFns } from "./acuTechnic3.vue?vue&type=template&id=6431ec88&scoped=true&"
var script = {}
import style0 from "./acuTechnic3.vue?vue&type=style&index=0&id=6431ec88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6431ec88",
  null
  
)

export default component.exports